const root = document.documentElement;

const screenWidth = window.matchMedia("(max-width:768px)");
const sel = (el) => document.querySelector(`${el}`);
const selAll = (el) => document.querySelectorAll(`${el}`);


// let once = true;

function observerCallback(mutations) {
    mutations.forEach(mutation => {
        if (mutation.target.classList.contains('single-office'))
            colorSwitcher(mutation.target);
    });
}

const observerColors = new MutationObserver(observerCallback);

observerColors.observe(root, {
    childList: true,
    subtree: true,
});

let onceSaveContent = true;

function colorSwitcher(target) {
    //office buttons
    const button = selAll('.main-offices .single-office');
    const subItems = selAll(".desktop-header .langs-warn .wpml-ls-sub-menu .wpml-ls-slot-shortcode_actions .wpml-ls-link span");

    subItems.forEach(val => val.addEventListener('click', () => {
        // if()
        const text = val.textContent;

        //fix this
        if (!localStorage.getItem('current-color')) {
            switch (true) {
                case text.toLowerCase().trim().includes('lt'): {
                    localStorage.setItem('current-color', 'lithuania');
                    break;
                }
                case text.toLowerCase().trim().includes('en'): {
                    localStorage.setItem('current-color', 'all');
                    break;
                }
                case text.toLowerCase().trim().includes('lv'): {
                    localStorage.setItem('current-color', 'latvia');
                    break;
                }
                case text.toLowerCase().trim().includes('ee'): {
                    localStorage.setItem('current-color', 'estonia');
                    break;
                }
                default: {
                    localStorage.setItem('current-color', 'all');
                }
            }
        }
        //

        localStorage.setItem('preffered-language', val.textContent.toLowerCase().trim());
    }));

    if (!localStorage.getItem('preffered-language')) {
        const location = document.documentElement.dataset.location.trim().toLowerCase();
        const chosenLang = sel(".desktop-header .langs-warn .wpml-ls-statics-shortcode_actions > ul > li > .lang-link span");
        const result = [...subItems].filter(val => val.textContent.toLowerCase().trim() !== chosenLang.textContent.toLowerCase().trim());

        result.forEach(lang => {
            if (location === 'se') {
                if (lang.textContent.trim().toLowerCase().includes('sv')) {
                    lang.click();
                }
            }

            if (location === 'ee') {
                if (lang.textContent.trim().toLowerCase().includes('et')) {
                    lang.click();
                }
            }

            if (lang.textContent.trim().toLowerCase() === location) {
                lang.click();
            }
        });

        if (chosenLang?.textContent.trim().toLowerCase() === location.trim().toLowerCase()) {
            subItems.forEach(val => {
                if (chosenLang.textContent.trim().toLowerCase() === val.textContent.toLowerCase().trim()) {
                    const text = val.textContent;

                    switch (true) {
                        case text.toLowerCase().trim().includes('lt'): {
                            localStorage.setItem('current-color', 'lithuania');
                            break;
                        }
                        case text.toLowerCase().trim().includes('en'): {
                            localStorage.setItem('current-color', 'all');
                            break;
                        }
                        case text.toLowerCase().trim().includes('lv'): {
                            localStorage.setItem('current-color', 'latvia');
                            break;
                        }
                        case text.toLowerCase().trim().includes('ee'): {
                            localStorage.setItem('current-color', 'estonia');
                            break;
                        }
                        default: {
                            localStorage.setItem('current-color', 'all');
                        }
                    }

                    val.click();
                    localStorage.setItem('preffered-language', val.textContent.toLowerCase().trim());
                }
            });
        }
    }
    //

    const colorProps = (mainColorProperty, mainColor, mainColorPropertyLight, mainColorLight, colorLogoProperty, colorLogo, colorBorderProperty, colorBorder, colorBtnProperty, colorBtn, btnToStrokeProperty, btnToStrokeColor, colorBtnTextProperty, colorBtnTextColor, colorBgProperty, colorBg, hoveredProperty, hoveredColor, btnCarouselProperty, btnCarouselColor, overlayProperty, overlayColor, colorFooterProperty, footerColor, colorBorderLinProperty, colorBorderLin) => {
        root.style.setProperty(mainColorProperty, mainColor);
        root.style.setProperty(mainColorPropertyLight, mainColorLight);
        root.style.setProperty(colorLogoProperty, colorLogo);
        root.style.setProperty(colorBorderProperty, colorBorder);
        root.style.setProperty(colorBtnProperty, colorBtn);
        root.style.setProperty(btnToStrokeProperty, btnToStrokeColor);
        root.style.setProperty(colorBtnTextProperty, colorBtnTextColor);
        root.style.setProperty(colorBgProperty, colorBg);
        root.style.setProperty(hoveredProperty, hoveredColor);
        root.style.setProperty(btnCarouselProperty, btnCarouselColor);
        root.style.setProperty(overlayProperty, overlayColor);
        root.style.setProperty(colorFooterProperty, footerColor);
        root.style.setProperty(colorBorderLinProperty, colorBorderLin);
    }

    function changeSpecificSelector(selector, property, color) {
        if (!document.querySelector(`${selector}`)) return;

        const sel = document.querySelectorAll(`${selector}`);
        sel.forEach(val => {
            val.style.setProperty(property, color);
        });
    }

    function changeBorderColor(selector, color) {
        if (!document.querySelector(`${selector}`)) return;

        const sel = document.querySelectorAll(`${selector}`);
        sel.forEach(val => {
            val.style.borderColor = `${color}`;
        });
    }

    function bgs(selector) {
        if (!document.querySelector(`${selector}`) || !localStorage.getItem('current-color')) return;
        let photos = document.querySelectorAll(`${selector}`);

        photos.forEach(ph => ph.classList.remove('active'));
        photos.forEach(photo => {
            if (photo.classList.contains(localStorage.getItem('current-color'))) {
                if (!photo.classList.contains('active')) {
                    photo.classList.add('active');
                }
            }
        });
    }

    if (screenWidth.matches) {
        bgs('.bright-future-section .future-photos-mobile .future-section-bg');
    } else {
        bgs('.bright-future-section .future-photos-desktop .future-section-bg');
    }

    bgs('.video-country');
    bgs('.top-section-bg');

    //colors
    const primaryColor = '--color-all';
    const primaryLightColor = '--color-all-light';
    const colorLogo = '--color-logo';
    const colorBorder = '--color-border';
    const colorBtn = '--color-border-button';
    const btnToStroke = '--color-btn-to-stroke';
    const colorBtnText = '--color-button';
    const bgDark = '--color-bg-dark';
    const hoveredColor = '--color-hovered';
    const borderCarouselBtnColor = '--color-btn-carousel-border';
    const colorOverlay = '--color-overlay';
    const colorFooter = '--color-footer';
    const colorBorderLin = '--color-border-lin';

    //logo lt jurex
    const lodoDefault = sel('#logo-df');
    const lt = sel('.logo-lt');

    const mode = language => {
        switch (language) {
            case 'all': {
                // lodoDefault.classList.remove('transparent');
                // lt.classList.add('transparent');
                colorProps(primaryColor, `#E0C084`, primaryLightColor, `#F2E0A4`, colorLogo, `#111918`, colorBorder, `#E0C084`, colorBtn, '#E0C084', btnToStroke, '#E0C084', colorBtnText, '#E0C084', bgDark, '#1C1C1C', hoveredColor, `#E0C084`, borderCarouselBtnColor, `#E0C084`, colorOverlay, `#E0C084`, colorFooter, '#E0C084', colorBorderLin, '#E0C084');

                //bottom blocks
                changeBorderColor(`.bottom-block a`, '#E0C084');

                //learn more button (people)
                changeBorderColor(`.learn-more-button span`, '#E0C084');

                //pagination current
                changeBorderColor(`.page-numbers.current`, '#E0C084');

                //homepage after dark section
                changeSpecificSelector('.bright-future-section .title span', '--color-all', 'black');

                //home middle block and inenr heros
                bgs('.video-country');
                bgs('.page-about .top-section-bg');
                bgs('.page-home .top-section-bg');
                bgs('.page-contacts .top-section-bg');
                bgs('.page-insights .top-section-bg');
                bgs('.page-people .top-section-bg');
                bgs('.page-experience .top-section-bg');
                bgs('.page-career .top-section-bg');

                //services
                bgs('.single-service .top-section-bg');

                if (screenWidth.matches) {
                    bgs('.bright-future-section .future-photos-mobile .future-section-bg');
                } else {
                    bgs('.bright-future-section .future-photos-desktop .future-section-bg');
                }
                break;
            }


            case 'lithuania': {
                // lodoDefault.classList.add('transparent');
                // lt.classList.remove('transparent');
                colorProps(primaryColor, `#55B299`, primaryLightColor, `#AAE0D3`, colorLogo, `#1B6A55`, colorBorder, `#55B299`, colorBtn, '#55B299', btnToStroke, '#B3E5D8', colorBtnText, '#55B299', bgDark, '#061C16', hoveredColor, `#55B299`, borderCarouselBtnColor, `#55B299`, colorOverlay, `#55B299`, colorFooter, '#B3E5D8', colorBorderLin, '#B3E5D8');

                //bottom blocks
                changeBorderColor(`.bottom-block a`, '#55B299');

                //learn more button (people)
                changeBorderColor(`.learn-more-button span`, '#55B299');

                //pagination current
                changeBorderColor(`.page-numbers.current`, '#55B299');

                //homepage after dark section
                changeSpecificSelector('.bright-future-section .title span', '--color-all', 'black');

                //home middle block and inenr heros
                bgs('.video-country');
                bgs('.page-about .top-section-bg');
                bgs('.page-home .top-section-bg');
                bgs('.page-contacts .top-section-bg');
                bgs('.page-insights .top-section-bg');
                bgs('.page-people .top-section-bg');
                bgs('.page-experience .top-section-bg');
                bgs('.page-career .top-section-bg');

                //services
                bgs('.single-service .top-section-bg');

                if (screenWidth.matches) {
                    bgs('.bright-future-section .future-photos-mobile .future-section-bg');
                } else {
                    bgs('.bright-future-section .future-photos-desktop .future-section-bg');
                }

                break;
            }
            case 'english': {

                break;
            }
            case 'estonia': {
                // lodoDefault.classList.remove('transparent');
                // lt.classList.add('transparent');

                colorProps(primaryColor, `#96B6DB`, primaryLightColor, `#B0C8E3`, colorLogo, `#008cc8`, colorBorder, '#B0C8E3', colorBtn, '#96B6DB', btnToStroke, '#B0C8E3', colorBtnText, '#96B6DB', bgDark, '#171E26', hoveredColor, `#008cc8`, borderCarouselBtnColor, `#96B6DB`, colorOverlay, `#B0C8E3`, colorFooter, '#B0C8E3', colorBorderLin, '#B0C8E3');

                //bottom blocks
                changeBorderColor(`.bottom-block a`, '#96B6DB');

                //learn more button (people)
                changeBorderColor(`.learn-more-button span`, '#96b6db');

                //pagination current
                changeBorderColor(`.page-numbers.current`, '#96b6db');

                // #96b6db

                //homepage after dark section
                changeSpecificSelector('.bright-future-section .title span', '--color-all', 'black');

                //home middle block and inenr heros
                bgs('.video-country');
                bgs('.page-about .top-section-bg');
                bgs('.page-home .top-section-bg');
                bgs('.page-contacts .top-section-bg');
                bgs('.page-insights .top-section-bg');
                bgs('.page-people .top-section-bg');
                bgs('.page-experience .top-section-bg');
                bgs('.page-career .top-section-bg');

                //services
                bgs('.single-service .top-section-bg');

                if (screenWidth.matches) {
                    bgs('.bright-future-section .future-photos-mobile .future-section-bg');
                } else {
                    bgs('.bright-future-section .future-photos-desktop .future-section-bg');
                }
                break;
            }
            case 'latvia': {
                // lodoDefault.classList.remove('transparent');
                // lt.classList.add('transparent');
                colorProps(primaryColor, `#C16D7A`, primaryLightColor, `#E6B7BF`, colorLogo, `#9D2235`, colorBorder, `#E6B7BF`, colorBtn, '#C16D7A', btnToStroke, '#E6B7BF', colorBtnText, '#C16D7A', bgDark, '#450F18', hoveredColor, `#C16D7A`, borderCarouselBtnColor, `#C16D7A`, colorOverlay, `#E6B7BF`, colorFooter, '#E6B7BF', colorBorderLin, '#E6B7BF');

                //bottom blocks
                changeBorderColor(`.bottom-block a`, '#C16D7A');

                //learn more button (people)
                changeBorderColor(`.learn-more-button span`, '#C16D7A');

                //pagination current
                changeBorderColor(`.page-numbers.current`, '#C16D7A');

                //homepage after dark section
                changeSpecificSelector('.bright-future-section .title span', '--color-all', 'black');

                //home middle block and inenr heros
                bgs('.video-country');
                bgs('.page-about .top-section-bg');
                bgs('.page-home .top-section-bg');
                bgs('.page-contacts .top-section-bg');
                bgs('.page-insights .top-section-bg');
                bgs('.page-people .top-section-bg');
                bgs('.page-experience .top-section-bg');
                bgs('.page-career .top-section-bg');

                //services
                bgs('.single-service .top-section-bg');

                if (screenWidth.matches) {
                    bgs('.bright-future-section .future-photos-mobile .future-section-bg');
                } else {
                    bgs('.bright-future-section .future-photos-desktop .future-section-bg');
                }
                break;
            }
        }
    }

    const conditionChecker = () => {
        if (localStorage.getItem('current-color')) {
            button.forEach(btn => btn.classList.remove('active-item'));
            mode(localStorage.getItem('current-color'));
            button.forEach(btn => {
                if (btn.classList.contains(localStorage.getItem('current-color'))) {
                    btn.classList.add('active-item');
                }
            });
        }
        // else {
        //     //delete this else when langs returned
        //     localStorage.setItem('current-color', 'all');
        //     mode(localStorage.getItem('current-color'));
        // }
    }

    let targetEl, saveContent;

    if (sel('.page-contacts .our-offices-section .subtitle h5')) {
        if (onceSaveContent) {
            targetEl = sel('.page-contacts .our-offices-section .subtitle h5');
            saveContent = targetEl?.textContent;
            onceSaveContent = false;
        }
    }

    //change contacts subtitle
    const contactsSubtitle = function () {
        if (!root.getAttribute('lang').includes('lv')) return;
        if (!sel('.page-template-page-contacts') || !saveContent) return;

        if (localStorage.getItem('current-color').includes('all')) {
            targetEl.textContent = saveContent;
            return;
        }

        const currentOffice = sel('.page-contacts .people-main-section .main-offices .active-item span');
        if (targetEl?.textContent.includes(currentOffice?.textContent)) return;

        targetEl.textContent = saveContent;

        if (currentOffice) {
            targetEl.textContent = targetEl.textContent.substring(0, targetEl.textContent.length - 1);
            targetEl.textContent += `s ${currentOffice.textContent}`;
        }
    }
    //

    //TRINITI JUREX
    const trinitiJurexReplace = function (selector, oldString, newString, method, state) {
        if (!document.querySelector(selector)) return;

        //auto jurex
        function nativeSelector() {
            const elements = document.querySelectorAll(`${selector}`);
            const results = [];
            let child;
            for (let i = 0; i < elements.length; i++) {
                child = elements[i].childNodes[0];
                if (elements[i].hasChildNodes() && child.nodeType == 3) {
                    results.push(child);
                }
            }
            return results;
        }

        let textnodes = nativeSelector(),
            _nv;

        const regex = new RegExp(oldString, method);

        if (state === 'forward') {
            for (let i = 0, len = textnodes.length; i < len; i++) {
                _nv = textnodes[i].nodeValue;
                if (!_nv.includes(newString))
                    textnodes[i].nodeValue = _nv.replace(regex, newString);
            }
        }

        if (state === 'back') {
            for (let i = 0, len = textnodes.length; i < len; i++) {
                _nv = textnodes[i].nodeValue;
                textnodes[i].nodeValue = _nv.replace(regex, newString);
            }
        }
    }

    setTimeout(() => {
        //
        if (localStorage.getItem('current-color')?.includes('lithuania')) {
            // trinitiJurexReplace('.copyright *', 'TRINITI', 'TRINITI JUREX', 'gi', 'forward');
            // trinitiJurexReplace('.page-career .bottom-block .title h2', 'TRINITI', 'TRINITI JUREX', 'gi', 'forward');
            // trinitiJurexReplace('.single-career .bottom-block .title h2', 'TRINITI', 'TRINITI JUREX', 'gi', 'forward');
            // trinitiJurexReplace('.desktop-header .nav-list .menu-item a', 'TRINITI', 'TRINITI JUREX', 'gi', 'forward');
            // trinitiJurexReplace('.navigation .single-nav a', 'TRINITI', 'TRINITI JUREX', 'gi', 'forward');
            // trinitiJurexReplace('#applyModal p', 'TRINITI', 'TRINITI JUREX', 'gi', 'forward');
            // trinitiJurexReplace('.page-template-page-about > main > section.top-section-inner > div.wrapper > div > div > div > div.title.animated > h1', 'TRINITI', 'TRINITI JUREX', 'gi', 'forward');
            // trinitiJurexReplace('body > div.header-sidebar > div.sidebar > div.menu-block > div.sidebar-pages > div > nav > ul > li:first-of-type > a', 'TRINITI', 'TRINITI JUREX', 'gi', 'forward');
        } else if (!localStorage.getItem('current-color')?.includes('lithuania')) {
            // trinitiJurexReplace('.copyright *', 'TRINITI JUREX', 'TRINITI', 'gi', 'back');
            // trinitiJurexReplace('.page-career .bottom-block .title h2', 'TRINITI JUREX', 'TRINITI', 'gi', 'back');
            // trinitiJurexReplace('.single-career .bottom-block .title h2', 'TRINITI JUREX', 'TRINITI', 'gi', 'back');
            // trinitiJurexReplace('.desktop-header .nav-list .menu-item a', 'TRINITI JUREX', 'TRINITI', 'gi', 'back');
            // trinitiJurexReplace('.navigation .single-nav a', 'TRINITI JUREX', 'TRINITI', 'gi', 'back');
            // trinitiJurexReplace('#applyModal p', 'TRINITI JUREX', 'TRINITI', 'gi', 'back');
            // trinitiJurexReplace('.page-template-page-about > main > section.top-section-inner > div.wrapper > div > div > div > div.title.animated > h1', 'TRINITI JUREX', 'TRINITI', 'gi', 'back');
            // trinitiJurexReplace('body > div.header-sidebar > div.sidebar > div.menu-block > div.sidebar-pages > div > nav > ul > li:first-of-type > a', 'TRINITI JUREX', 'TRINITI', 'gi', 'back');
        }

        if (screenWidth.matches) {
            if (sel('.page-template-page-about > main > section.top-section-inner > div.wrapper > div > div > div > div.text')) {
                const container = sel('body > main > section.top-section-inner > div.wrapper');
                const topSectionBgs = selAll('body > main > section.top-section-inner > div.top-section-bg');
                const leftGlass = sel('body > main > section.top-section-inner > div.left-glass-bg');

                leftGlass.style.height = `calc(${container.clientHeight / (document.documentElement.clientWidth / 100)}vw + 50vw)`;

                topSectionBgs.forEach((val, i) => {
                    val.style.top = `calc(${container.clientHeight / (document.documentElement.clientWidth / 100)}vw + 35vw)`;
                });
            }
        }

        contactsSubtitle();
    }, 1000);


    //
    conditionChecker();

    button.forEach((btn, i) => btn.addEventListener('click', function () {
        button.forEach(val => val.classList.remove('active-item'));
        btn.classList.add('active-item');

        if (sel('.lt-only')) {
            const lt = selAll('.lt-only');
            console.log(localStorage.getItem('current-color'));
            if (localStorage.getItem('current-color').includes('lithuania')) {
                // lt.forEach(val => {
                //     val.style.display = 'flex';
                // })
            } else {
                // lt.forEach(val => {
                //     val.style.display = 'none';
                // })
            }
        }

        const currentClass = this.classList;

        switch (currentClass.contains('single-office')) {
            case currentClass.contains('latvia'): {
                localStorage.setItem('current-color', 'latvia');
                break;
            }
            case currentClass.contains('lithuania'): {
                localStorage.setItem('current-color', 'lithuania');
                break;
            }
            case currentClass.contains('estonia'): {
                localStorage.setItem('current-color', 'estonia');
                break;
            }
            case currentClass.contains('all'): {
                localStorage.setItem('current-color', 'all');
                break;
            }
        }

        //TRINITI JUREX
        const trinitiJurexReplace = function (selector, oldString, newString, method, state) {
            if (!document.querySelector(selector)) return;

            //auto jurex


            function nativeSelector() {
                const elements = document.querySelectorAll(`${selector}`);
                const results = [];
                let child;
                for (let i = 0; i < elements.length; i++) {
                    child = elements[i].childNodes[0];
                    if (elements[i].hasChildNodes() && child.nodeType == 3) {
                        results.push(child);
                    }
                }
                return results;
            }

            let textnodes = nativeSelector(),
                _nv;

            const regex = new RegExp(oldString, method);

            if (state === 'forward') {
                for (let i = 0, len = textnodes.length; i < len; i++) {
                    _nv = textnodes[i].nodeValue;
                    if (!_nv.includes(newString))
                        textnodes[i].nodeValue = _nv.replace(regex, newString);
                }
            }

            if (state === 'back') {
                for (let i = 0, len = textnodes.length; i < len; i++) {
                    _nv = textnodes[i].nodeValue;
                    textnodes[i].nodeValue = _nv.replace(regex, newString);
                }
            }
        }

        //
        if (localStorage.getItem('current-color')?.includes('lithuania')) {
            // trinitiJurexReplace('.copyright *', 'TRINITI', 'TRINITI JUREX', 'gi', 'forward');
            // trinitiJurexReplace('.page-career .bottom-block .title h2', 'TRINITI', 'TRINITI JUREX', 'gi', 'forward');
            // trinitiJurexReplace('.single-career .bottom-block .title h2', 'TRINITI', 'TRINITI JUREX', 'gi', 'forward');
            // trinitiJurexReplace('.desktop-header .nav-list .menu-item a', 'TRINITI', 'TRINITI JUREX', 'gi', 'forward');
            // trinitiJurexReplace('#applyModal p', 'TRINITI', 'TRINITI JUREX', 'gi', 'forward');
            // trinitiJurexReplace('.page-template-page-about > main > section.top-section-inner > div.wrapper > div > div > div > div.title.animated > h1', 'TRINITI', 'TRINITI JUREX', 'gi', 'forward');
            // trinitiJurexReplace('body > div.header-sidebar > div.sidebar > div.menu-block > div.sidebar-pages > div > nav > ul > li:first-of-type > a', 'TRINITI', 'TRINITI JUREX', 'gi', 'forward');
        } else if (!localStorage.getItem('current-color')?.includes('lithuania')) {
            // trinitiJurexReplace('.copyright *', 'TRINITI JUREX', 'TRINITI', 'gi', 'back');
            // trinitiJurexReplace('.page-career .bottom-block .title h2', 'TRINITI JUREX', 'TRINITI', 'gi', 'back');
            // trinitiJurexReplace('.single-career .bottom-block .title h2', 'TRINITI JUREX', 'TRINITI', 'gi', 'back');
            // trinitiJurexReplace('.desktop-header .nav-list .menu-item a', 'TRINITI JUREX', 'TRINITI', 'gi', 'back');
            // trinitiJurexReplace('#applyModal p', 'TRINITI JUREX', 'TRINITI', 'gi', 'back');
            // trinitiJurexReplace('.page-template-page-about > main > section.top-section-inner > div.wrapper > div > div > div > div.title.animated > h1', 'TRINITI JUREX', 'TRINITI', 'gi', 'back');
            // trinitiJurexReplace('body > div.header-sidebar > div.sidebar > div.menu-block > div.sidebar-pages > div > nav > ul > li:first-of-type > a', 'TRINITI JUREX', 'TRINITI', 'gi', 'back');
        }
        contactsSubtitle();
        if (screenWidth.matches) {
            if (sel('.page-template-page-about > main > section.top-section-inner > div.wrapper > div > div > div > div.text')) {
                const container = sel('body > main > section.top-section-inner > div.wrapper');
                const topSectionBgs = selAll('body > main > section.top-section-inner > div.top-section-bg');
                const leftGlass = sel('body > main > section.top-section-inner > div.left-glass-bg');

                leftGlass.style.height = `calc(${container.clientHeight / (document.documentElement.clientWidth / 100)}vw + 50vw)`;

                topSectionBgs.forEach((val, i) => {
                    val.style.top = `calc(${container.clientHeight / (document.documentElement.clientWidth / 100)}vw + 35vw)`;
                });
            }
        }
        conditionChecker();
    }));
}

//filter buttons click
const buttonAttachment = function () {
    const button = selAll('.main-offices .single-office');
    const filterButtons = selAll('.sf-field-taxonomy-person_countries > ul > li > label');

    filterButtons.forEach((btn, i) => btn.addEventListener('click', function () {
        filterButtons.forEach(val => val.classList.remove('active-item'));
        button[i].click();
    }));
}


function filterObserverCallback(mutations) {
    mutations.forEach(mutation => {
        if (mutation.target.classList.contains('sf-field-taxonomy-person_countries'))
            buttonAttachment();
    });
}

const filterObserver = new MutationObserver(filterObserverCallback);

filterObserver.observe(root, {
    childList: true,
    subtree: true,
});

jQuery(document).ready(function ($) {
    $(document).ajaxComplete(function () {
        const desktopHeader = selAll('.header-langs-diff .people-main-section .single-office');
        const filterButtons = selAll('.sf-field-taxonomy-person_countries > ul > li > label');
        desktopHeader.forEach((btn, i) => btn.addEventListener('click', () => {
            filterButtons[i].click();
        }));
    });

    if (sel('.lt-only')) {
        const lt = selAll('.lt-only');
        if (localStorage.getItem('current-color').includes('lithuania')) {
            // lt.forEach(val => {
            //     val.style.display = 'flex';
            // })
        } else {
            // lt.forEach(val => {
            //     val.style.display = 'none';
            // })
        }
    }
});

//en - https://triniti.eu/wp-content/uploads/2022/07/screenshot-EN-scaled.jpg
//lt - https://triniti.eu/wp-content/uploads/2022/07/screenshot-LT-1.png
//ee - https://triniti.eu/wp-content/uploads/2022/07/screenshot-EE-scaled.jpg
//lv - https://triniti.eu/wp-content/uploads/2022/07/screenshot-LV-scaled.jpg

// <div className="top-section-bg hero-mobile-photo all
//                 if ($i === 1) echo ' active'; ?>"
//      style="background: url(https://triniti.eu/wp-content/uploads/2022/07/screenshot-EN-scaled.jpg) center / cover no-repeat;"></div>
// <div className="top-section-bg hero-mobile-photo estonia
//                 if ($i === 1) echo ' active'; ?>"
//      style="background: url() center / cover no-repeat;"></div>
// <div className="top-section-bg hero-mobile-photo latvia
//                 if ($i === 1) echo ' active'; ?>"
//      style="background: url() center / cover no-repeat;"></div>
// <div className="top-section-bg hero-mobile-photo lithuania
//                 if ($i === 1) echo ' active'; ?>"
//      style="background: url(https://triniti.eu/wp-content/uploads/2022/07/screenshot-LT-1.png) center / cover no-repeat;"></div>
//